import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import {ENV_CONFIG, EnvConfig} from './configuration';
import {ApiBaseUrl} from './app/shared/apis/api.client';

(async () => {
  try {
    const envConfig: EnvConfig = await fetch('assets/data/configuration.json').then(res => res.json());

    if (envConfig.production) {
      enableProdMode();
    }

    platformBrowserDynamic([
      { provide: ENV_CONFIG, useValue: envConfig },
      { provide: ApiBaseUrl, useValue: envConfig.appConfig.apiBaseUrl },
    ])
      .bootstrapModule(AppModule)
      .catch(err => console.error(err));
  } catch (e) {
    console.error(`Load pre-initialize configuration error: ${e}`);
  }
})();
